import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/services/AuthService/auth.service';

type UserType = 'PF' | 'PJ' | 'FUNC';

@Component({
  selector: 'login-switch',
  templateUrl: './login-switch.component.html',
  styleUrls: ['./login-switch.component.scss']
})
export class LoginSwitchComponent {
  @Input() userType: UserType = 'PJ';
  @Output() userTypeChanged = new EventEmitter<UserType>();

  constructor(private authService: AuthService) {
    const storedType = localStorage.getItem('usuarioTipo') as UserType;
    if (storedType) {
      this.userType = storedType;
      this.authService.setUserType(storedType);
    } else {
      localStorage.setItem('usuarioTipo', 'PJ');
      this.authService.setUserType('PJ');
    }
  }

  setUserType(userType: UserType): void {
    if (this.userType === userType) {
      return;
    }

    this.userType = userType;
    localStorage.setItem('usuarioTipo', userType);
    this.authService.setUserType(userType);

    this.userTypeChanged.emit(userType);
  }
}
